@if (headingLevel() === 1) {
  <h1
    class="col-1-12 flex flex--middle mr-medium-b font-heading-3 nordic-blue-900-text text-icon-primary font-headline-medium"
  >
    <fcom-icon class="icon-large ms-small-r" [name]="icon()" />
    <span>{{ heading() }}</span>
  </h1>
} @else {
  <h2
    class="col-1-12 flex flex--middle mr-small-b font-heading-3 nordic-blue-900-text text-icon-primary font-headline-small"
  >
    <fcom-icon class="icon-large ms-small-r" [name]="icon()" />
    <span>{{ heading() }}</span>
  </h2>
}

@if (loading()) {
  <fcom-loader class="block col-1-12 ms-large-y" [loaderType]="loaderType()" data-testid="suggested-routes-loader" />
} @else if (groups(); as groups) {
  <div class="link-groups col-1-12 g-large ms-xxlarge-b">
    @for (group of groups; track $index) {
      <div class="flex flex--column flex--align-start g-small">
        @if (group.headingArgs; as headingArgs) {
          @if (headingLevel() === 1) {
            <h2 class="mr-clear font-heading-5 nordic-blue-900-text text-icon-primary font-title-small medium-type">
              {{ groupHeadingKey() | finLocalization: headingArgs }}
            </h2>
          } @else {
            <h3 class="mr-clear font-heading-5 nordic-blue-900-text text-icon-primary font-title-small medium-type">
              {{ groupHeadingKey() | finLocalization: headingArgs }}
            </h3>
          }
        }

        @for (link of group.links; track link.href) {
          <fcom-link
            [href]="link.disabled ? undefined : link.href"
            [disabled]="link.disabled"
            [icon]="{
              position: IconPosition.RIGHT,
              name: link.disabled ? SvgLibraryIcon.CHECKMARK_BUTTON_SELECTED : SvgLibraryIcon.ARROW_RIGHT,
              extraClasses: link.disabled ? 'success-900-text signal-success-notification-border-icon-text' : undefined,
            }"
          >
            {{ labelKey() | finLocalization: link.args }}
          </fcom-link>
        }
      </div>
    }
  </div>
}
